export const FS_NEW_LINK_SHARE = 'content_enable_new_link_share';
